import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import LoginPage from './pages/LoginPage'
import ChangePasswordPage from './pages/ChangePasswordPage'
import UsersPage from './pages/UsersPage'
import ApplicationsPage from './pages/ApplicationsPage'
import ApplicationDetailPage from './pages/ApplicationDetailPage'
import ApiTrafficPage from './pages/ApiTrafficPage'
import ApiTrafficDetailPage from './pages/ApiTrafficDetailPage'
import BrokersPage from './pages/BrokersPage'
import BrokerDetailPage from './pages/BrokerDetailPage'
import SubmitToLendersPage from './pages/SubmitToLendersPage'
import DashboardPage from './pages/DashboardPage'

function App() {
    return (
        <AuthProvider>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <DashboardPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <UsersPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/applications"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <ApplicationsPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/applications/:id"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <ApplicationDetailPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/applications/:id/submittolenders"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <SubmitToLendersPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/change-password"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <ChangePasswordPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/brokers"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <BrokersPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/brokers/:id"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <BrokerDetailPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/api-traffic"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <ApiTrafficPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/api-traffic/:id"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <ApiTrafficDetailPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </AuthProvider>
    )
}

export default App
